import React, { Component } from 'react';
import { connect } from 'react-redux';

import { percentify } from 'utilities/videoPlayer';

import './styles.less';

class CommentBar extends Component {
  render() {
    const { commentMarkers, duration } = this.props;

    const comments = commentMarkers.map((marker, ind) => {
      const { time } = marker;
      const markerStyle = { left: percentify(time, duration) };

      return <span key={ind} className="comment-marker" style={markerStyle} />;
    });

    return (
      <div
        className="video-player-comment-bar"
        onMouseMove={this.props.onMouseMove}
        onMouseOut={this.props.onMouseOut}
      >
        {comments}
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { comment_markers: commentMarkers } = state.video_player;

  return { commentMarkers };
};

export default connect(mapStateToProps)(CommentBar);
